import { Component, OnInit } from '@angular/core';
import { GateOutService } from '../../../../service/gate-out/gate-out-service';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GateInService } from '../../../../service/gate-in/gate-in.service';
import { MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { GateOut } from '../../../../models/gate-out';

interface POItem {
  poNumber: string;
  details: string;
  items: Item[];
}

interface Item {
  poagreement_no: string;
  item_no: string;
  material_code: string;
  description: string;
  quantity: number;
  received_qty: number;
  uom: string;
}


@Component({
  selector: 'app-gate-out',
  templateUrl: './gate-out.component.html',
  styleUrl: './gate-out.component.scss'
})
export class GateOutComponent implements OnInit {

  gateOutForm!: FormGroup
  gateEntryDetail: any;
  // poDetails: POItem[] = [];
  gate_in_unloading_list: any[] = [];

  gateEntryData: any[] = [];

  poDetailsArray!: FormArray;
  showAccordion: boolean = false;

  createGateOutDto!:GateOut

  recordDetails = {
    poNumber: '',
    agNumber: '',
    gateNumber: '',

    poAccordions: [] as POItem[],

  };

  constructor(
    private gateOutService: GateOutService,
    private gateInService: GateInService,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private datePipe: DatePipe,

  ) {
    this.createGateOutDto = new GateOut()
   }
  ngOnInit(): void {

    this.gateOutForm = this.formBuilder.group({
      plant: ['', Validators.required],
      gate: ['', Validators.required],
      gate_entry_no: ['', Validators.required],
      total_net_weight: [''],
      total_gross_weight: [''],
      remark_1: [''],
      remark_2: [''],
      purpose: [''],
      invoice:[''],
      driver:[''],
      driver_mobile_no:[''],
      vehicle:[''],
      e_way_bill_no:[''],
      total_invoice_value:[''],
      origin_of_country:[''],
      created_by:[''],
      created_on:[''],
      received_by:[''],
      docket_date:[''],
      docket_no:[''],
      loading_unloading_point:[''],
      boe_no:[''],
      boe_date:[''],
      invoice_date:[''],
      number_of_packages:[''],
      gate_number:[''],
      poDetails: this.formBuilder.array([])
    });

    // this.poDetailsArray = this.gateOutForm.get('poDetails') as FormArray;
    this.getAllGateInUnloading()
    this.getUserDetail()
  }

  get poDetails() {
    return this.gateOutForm.get('poDetails') as FormArray;
  }

  getAllGateInUnloading() {
    this.gateOutService.getAllGateInUnloading().then((res) => {
      this.gate_in_unloading_list = res.message.get_gate_in_unloading_detail
    }).catch((error) => {
      console.log(error)
    })
  }

  getUserDetail() {
    this.gateInService.getUserDetail().then((res) => {
      this.gateOutForm.patchValue({
        plant: res.message.plant_and_gate_details.name,
        gate: res.message.plant_and_gate_details.gate[0].gate
      });

    }).catch((error) => {
      console.log(error)
    })
  }

  onTokenNoSelected(name: any) {
    if(!name){
      this.showAccordion = false;
      this.clearFormArray();
      this.gateOutForm.reset();
      this.recordDetails.poAccordions = [];
    }else{
      this.clearFormArray();
      this.getSelectedGateInData(name)
    }

  }

  patchValues(data:[],data1:any){
    data.forEach((obj:any) => {
      const formGroup = this.formBuilder.group({
        poagreement_no:[''],
        company_code: [''],
        company_name: [''],
        doc_cat: [''],
        doc_type: [''],
        vendor_code:[''],
        vendor_name:[''],
        plant_code:[''],
        plant_name:[''],
      });
  formGroup.get('poagreement_no')?.setValue(obj.poagreement_no);
  formGroup.get('company_code')?.setValue(obj.company_code);
  formGroup.get('company_name')?.setValue(obj.name1);
  formGroup.get('doc_cat')?.setValue(obj.doc_cat);
  formGroup.get('doc_type')?.setValue(obj.doc_type);
  formGroup.get('vendor_name')?.setValue(obj.vendor);
  formGroup.get('vendor_code')?.setValue(obj.vendor_code);
  formGroup.get('plant_code')?.setValue(data1.plant_code);
  formGroup.get('plant_name')?.setValue(data1.plant_name);

  this.poDetails.push(formGroup);

    })
  }

  getSelectedGateInData(name: any) {
    this.gateOutService.getSelectedGateInData(name).then((res) => {
      const gateEntryDetail = res.message.gate_entry_data
      this.gateEntryData = res.message.gate_entry_data
      const formattedDate = this.datePipe.transform(gateEntryDetail.boe_date, 'dd/MM/yyyy');
      this.gateOutForm.get('boe_date')?.setValue(formattedDate)
      this.gateOutForm.get('boe_no')?.setValue(gateEntryDetail.boe_no)
      this.gateOutForm.get('created_by')?.setValue(gateEntryDetail.created_by)
      this.gateOutForm.get('created_on')?.setValue(gateEntryDetail.created_on)
      const formattedDate1 = this.datePipe.transform(gateEntryDetail.docket_date, 'dd/MM/yyyy');
      this.gateOutForm.get('docket_date')?.setValue(formattedDate1)
      this.gateOutForm.get('docket_no')?.setValue(gateEntryDetail.docket_no)
      this.gateOutForm.get('driver')?.setValue(gateEntryDetail.driver)
      this.gateOutForm.get('e_way_bill_no')?.setValue(gateEntryDetail.e_way_bill_no)
      this.gateOutForm.get('invoice')?.setValue(gateEntryDetail.invoice)
      this.gateOutForm.get('loading_unloading_point')?.setValue(gateEntryDetail.loading_unloading_point)
      this.gateOutForm.get('origin_of_country')?.setValue(gateEntryDetail.origin_of_country)
      this.gateOutForm.get('plant')?.setValue(gateEntryDetail.plant)
      this.gateOutForm.get('gate')?.setValue(gateEntryDetail.gate)
      this.gateOutForm.get('purpose')?.setValue(gateEntryDetail.purpose)
      this.gateOutForm.get('received_by')?.setValue(gateEntryDetail.received_by)
      this.gateOutForm.get('remark_1')?.setValue(gateEntryDetail.remark_1)
      this.gateOutForm.get('remark_2')?.setValue(gateEntryDetail.remark_2)
      this.gateOutForm.get('total_gross_weight')?.setValue(gateEntryDetail.total_gross_weight)
      this.gateOutForm.get('total_invoice_value')?.setValue(gateEntryDetail.total_invoice_value)
      this.gateOutForm.get('total_net_weight')?.setValue(gateEntryDetail.total_net_weight)
      this.gateOutForm.get('vehicle')?.setValue(gateEntryDetail.vehicle)
      this.gateOutForm.get('driver_mobile_no')?.setValue(gateEntryDetail.mobile_no)
      const formattedDate2 = this.datePipe.transform(gateEntryDetail.invoice_date, 'dd/MM/yyyy');
      this.gateOutForm.get('invoice_date')?.setValue(formattedDate2)
      this.gateOutForm.get('number_of_packages')?.setValue(gateEntryDetail.no_of_packages)
      this.gateOutForm.get('gate_number')?.setValue(gateEntryDetail.gate_no)

      const poDetails = res.message.po_details;
      if(poDetails.length > 0){
        this.showAccordion = true
      }else{
        this.showAccordion = false
      }
      this.patchValues(poDetails,gateEntryDetail)
      this.recordDetails.poAccordions = [];
      this.recordDetails.poAccordions = poDetails.map((po: any) => ({
        items:po.item_details.map((item: Item) => ({
          poNumber:po.poagreement_no,
          itemNo: item.item_no,
          materialCode: item.material_code,
          materialDescription:item.description,
          poQty:item.quantity,
          receivedQty:item.received_qty,
          uom:item.uom,
        }))
      }));
    }).catch((error) => {
      console.log(error);
      this.showAccordion = false;
      this.recordDetails.poAccordions = [];
    });
  }



  onSubmit() {
    if (this.gateOutForm.valid) {

    this.createGateOutDto.gate_entry_no=this.gateOutForm.get('gate_entry_no')?.value
    this.createGateOutDto.total_gross_weight=this.gateOutForm.get('total_gross_weight')?.value
    this.createGateOutDto.total_net_weight=this.gateOutForm.get('total_net_weight')?.value
    this.createGateOutDto.remark_1=this.gateOutForm.get('remark_1')?.value
    this.createGateOutDto.remark_2=this.gateOutForm.get('remark_2')?.value

    this.gateOutService.createGateOut(this.createGateOutDto)
      .then((res) => {
        const { message } = res;
        const severity = message.status === 'Success' ? 'success' : 'error';
        this.messageService.add({ severity, summary: message.status, detail: message.message });
        this.gateOutForm.reset();
        this.poDetails.clear()
      })
      .catch(() => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while processing your request.' });
      });
     } else {
        this.gateOutForm.markAllAsTouched();
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill in all required fields correctly.' });
      }
  }

  clearFormArray() {
    while (this.poDetails.length !== 0) {
      this.poDetails.removeAt(0);
    }
  }


}
